module.exports = __webpack_public_path__ + "img/112.9e70c51c.jpg";